<template>
    <div class="form-group" :class="computedClasses">
        <textarea
            ref="textarea"
            class="form-control city-textarea"
            :class="[{'no-resize': noResize}, inputClasses]"
            :disabled="disabled"
            :readonly="readonly"
            :rows="rows"
            :id="id"
            :name="name"
            v-model.trim="mutableValue">
        </textarea>
        <label :for="id" class="material-label" :class="{'active': mutableValue}"><slot></slot></label>
        <small v-if="error" class="invalid-feedback">{{ error }}</small>
        <help-span :helpText="helpText" />
    </div>
</template>

<script>
export default {
    name: 'material-textarea',
    components: {
        HelpSpan: () => import(/* webpackChunkName: "help-span" */ '@/components/form/HelpSpan.vue'),
    },
    computed: {
        computedErrors () {
            return typeof this.errorMessages === 'string'
            ? [this.errorMessages] : this.errorMessages
        },
        computedClasses () {
            return {
                'material--has-errors': this.hasErrors,
                'material--raised': Boolean(this.mutableValue) // has value
            }
        },
        hasErrors() {
            return !this.valid || (this.errorMessages && this.errorMessages.length)
        },
        translatedHelpText() {
            return this.helpText ? this.$t(this.helpText) : null;
        }
    },
    data () {
        return {
            mutableValue: null,
            valid: true
        }
    },
    beforeMount () {
      // Here we are following the Vue2 convention on custom v-model:
      // https://github.com/vuejs/vue/issues/2873#issuecomment-223759341
      this.copyValue(this.value)
    },
    mounted() {

    },
    methods: {
        copyValue (value) {
            this.mutableValue = value;
        },
        onChange(value) {
            this.$emit('input', value);
            // this.handleValidation();
            this.valid = this.$refs.textarea ? this.$refs.textarea.validity.valid : this.valid
        },
    },
    watch: {
        value (newValue) {
            // This watch works from the code side of the 2-way-binding:
            this.copyValue(newValue)
        },
        mutableValue(newValue) {
            this.onChange(newValue);
        },
    },
    props: {
        id: {
            type: String,
        },
        name: {
            type: String,
            default: null
        },
        value: {
            default: null
        },
        rows: {
            type: Number,
            default: 3
        },
        readonly: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        noResize: {
            type: Boolean,
            default: false
        },
        errorMessages: {
            type: [Array, String],
            default: null
        },
        inputClasses: {
            type: [Array, Object, String],
            default: null
        },
        error: {
            type: String,
            default: null
        },
        helpText: {
            type: String,
            default: null
        },
    }
}
</script>
